export const environment = {
    production: false,
    baseUrl: "https://api-onlineordering.getsonic.co",
    googleMapsApiKey: "AIzaSyAT4H2_QEoiQGBp87FiM3c98DpZteo6LwQ"
};
